import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAuth } from "../lib/AuthContext";
import { CircleNotch } from "@phosphor-icons/react";

const LoginPage = () => {
  const { isAuthenticated, loading, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (isAuthenticated) {
      navigate("/dashboard", { replace: true });
    } else {
      login({ appState: { returnTo: "/dashboard" } });
    }
  }, [loading, isAuthenticated, navigate, login]);

  return (
    <>
      <Helmet>
        <title>Sign In | NPI Lookup</title>
      </Helmet>
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <CircleNotch className="w-8 h-8 text-teal animate-spin mx-auto mb-3" />
          <p className="text-slate-500 text-sm">Redirecting to sign in...</p>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
